import { SettingsIcon } from '@carboncopyco/icons';
import {
  Button,
  Dropdown,
  DropdownItem,
  TextBase,
  TextCaption,
  Toggle,
} from '@carboncopyco/ui';
import { useDashboardAnalytics } from '@carboncopyco/utils';
import { useDashboardProps } from '../DashboardContext';

export const SettingsMenu = () => {
  const { short, setShort, internal, setInternal } = useDashboardProps();
  const {
    trackDashboardInternalSessionsClick,
    trackDashboardShortSessionsClick,
  } = useDashboardAnalytics();

  const config = [
    {
      title: 'Include internal users sessions',
      description: "Count internal users' visits to sandboxes and tours",
      checked: internal,
      onCheckChange: () => {
        setInternal(!internal);
        trackDashboardInternalSessionsClick({
          dashboardInternalSessions: !internal ? 'include' : 'exclude',
        });
      },
    },
    {
      title: 'Include short sessions',
      description: 'Count live demo sessions that lasted less than 3 minutes',
      checked: short,
      onCheckChange: () => {
        setShort(!short);
        trackDashboardShortSessionsClick({
          dashboardShortSessions: !short ? 'include' : 'exclude',
        });
      },
    },
  ];

  return (
    <Dropdown
      asChild
      triggerElement={
        <Button
          secondary
          icon={<SettingsIcon />}
        />
      }
      align="end"
      width={323}
    >
      {config.map(({ title, description, checked, onCheckChange }) => (
        <DropdownItem
          key={title}
          onClick={(event) => event.preventDefault()}
          asChild
        >
          <div className="flex justify-between p-4 cursor-auto">
            <div className="flex flex-col max-w-[230px]">
              <TextBase
                label={title}
                color="text-ds-natural-600"
              />
              <TextCaption label={description} />
            </div>
            <div className="pr-6 pt-2">
              <Toggle
                checked={Boolean(checked)}
                onChange={onCheckChange}
              />
            </div>
          </div>
        </DropdownItem>
      ))}
    </Dropdown>
  );
};
